import { useMutation, useQuery } from 'react-query'
import { GerarPedidoOrcamentoService } from '../service/gerar-pedido-orcamento-service'
import { useToast } from '@chakra-ui/react'

const gerarPedidoOrcamento = new GerarPedidoOrcamentoService()

export const useGerarPedidoOrcamento = () => {
  const toast = useToast({
    position: 'top-right',
    duration: 3000,
    isClosable: true,
  })

  const { mutateAsync: solicitarCaricatura, isLoading: isLoadingSolicitarCaricatura } = useMutation({
    mutationFn: (data) => gerarPedidoOrcamento.solicitarCaricatura(data),
    onSuccess: () => {
      toast({
        title: 'Caricatura solicitada com sucesso',
        status: 'success',
      })
    },
    onError: (error) => {
      toast({
        title: 'Erro ao solicitar caricatura',
        description: error.response.data.erros,
        status: 'error',
      })
    },
  })

  return { solicitarCaricatura, isLoadingSolicitarCaricatura }
}
